import React from 'react';
import {TableInstance} from 'react-table';
import styled from 'styled-components';

import {flexCenter} from '../../../../../libs/shared/ui/src/styles/mixins';
import {TablePageSelector} from './tablePageSelector';
import {TablePageSizeDropdownBox} from './tablePageSizeDropdown';

/*
 * Props.
 */

interface TablePaginationProps<T extends object> {
  instance: TableInstance<T>;
  isLoading?: boolean;
}

/*
 * Styles.
 */

const StyledPaginationContainer = styled.div`
  ${flexCenter};
  justify-content: space-between;
  padding-top: 19px;
  color: ${(p) => p.theme.greys.shade80};
`;

const StyledPageSizeActions = styled.div`
  ${flexCenter};
`;

const StyledRowPerPage = styled.span`
  margin-right: 8px;
`;

const StyledNumberRows = styled.span`
  margin-left: 8px;
`;

/*
 * Component.
 */

export const TablePagination = <T extends object>({instance, isLoading}: TablePaginationProps<T>) => {
  const {
    rows,
    setPageSize,
    state: {pageIndex, pageSize},
  } = instance;

  return (
    <StyledPaginationContainer>
      <StyledPageSizeActions>
        <StyledRowPerPage>Rows per page</StyledRowPerPage>
        <TablePageSizeDropdownBox
          selectedPageSize={pageSize}
          onPageSizeSelect={setPageSize}
          isLoading={isLoading}
        />
        <StyledNumberRows>
          {pageIndex * pageSize + 1} - {Math.min(rows.length, (pageIndex + 1) * pageSize)} of {rows.length}
        </StyledNumberRows>
      </StyledPageSizeActions>
      <TablePageSelector instance={instance} isLoading={isLoading} />
    </StyledPaginationContainer>
  );
};
